import repoUrls from 'src/sections/repository/urls';

import {
  ARTIFACTS_PAGE_LENGTH,
  PAGE_QUERY_PARAM,
  PAGELEN_QUERY_PARAM,
  SEARCH_MAVEN_BASE_VERSION_QUERY_PARAM,
  SORT_QUERY_PARAM,
} from '../../constants';
import { MavenBaseVersionsResponse } from '../../types';
import { buildPackagesApiQueryString } from '../../utils';
import { packagesResourceFactory } from '../utils';

export const packagesMavenBaseVersionsResource =
  packagesResourceFactory<MavenBaseVersionsResponse>()({
    key: 'packages-maven-base-versions',
    pathParamNames: ['packageName'] as const,
    queryParamNames: [
      SORT_QUERY_PARAM,
      PAGE_QUERY_PARAM,
      SEARCH_MAVEN_BASE_VERSION_QUERY_PARAM,
    ] as const,
    getRequestUrl: (context, pathParams, queryParams) => {
      const queryString = buildPackagesApiQueryString({
        ...queryParams,
        packageName: pathParams.packageName,
        [PAGELEN_QUERY_PARAM]: ARTIFACTS_PAGE_LENGTH.toString(),
      });

      switch (context.container) {
        case 'repository':
          return repoUrls.api.internal.mavenBaseVersions(
            context.workspaceSlug,
            context.repositorySlug,
            queryString
          );
        default:
          throw new Error('Invalid route context');
      }
    },
  });
